import React from "react";
import { withAdminLayout } from "../../../hoc";
import HomeView from "./view";

const AdminHomePage = () => {
  return <HomeView />;
};

export default withAdminLayout(AdminHomePage);
